import { render, staticRenderFns } from "./AdminMainMenu.vue?vue&type=template&id=1e15bae5&scoped=true&"
import script from "./AdminMainMenu.vue?vue&type=script&lang=js&"
export * from "./AdminMainMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminMainMenu.vue?vue&type=style&index=0&id=1e15bae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e15bae5",
  null
  
)

export default component.exports